import LinearSourceIcon from "../../assets/components/sources/LinearSourceIcon";

const LinearLogomark = ({ height }: { height: number }) => {
  return <LinearSourceIcon height={height} />;
};

export default LinearLogomark;
